import { data_from_server_post } from '@/shared/http/client';
export async function fetchModelDetails({ client_id, distillation_event_id }) {
  return await data_from_server_post('model-details', {
    client_id,
    distillation_event_id,
  });
}

export async function updateModelNotes({ client_id, distillation_event_id, model_notes }) {
  return await data_from_server_post('model-details/model-notes', {
    client_id,
    distillation_event_id,
    model_notes,
  });
}

